var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tlqn-circular-progress"},[_c('q-circular-progress',{style:({
      boxShadow: ("inset 0 0 calc(" + _vm.thickness + " / 2) rgba(255,255,255,1)"),
      borderRadius: '50%',
    }),attrs:{"show-value":false,"value":_vm._p,"size":_vm.size,"color":"primary","track-color":"transparent","thickness":0.5}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }